import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TriangleIcon = () => (_jsxs("svg", { height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("path", { d: "M0 0h24v24H0z", fill: "none" }), _jsx("path", { d: "M1 21h22L12 2" })] }));
